import React from 'react';
import Marquee from 'react-fast-marquee';
import { Star, Quote } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { TESTIMONIALS } from '../../data/siteData';

const Stars = ({ n }) => (
  <div className="flex gap-0.5">
    {[...Array(5)].map((_, i) => (
      <Star key={i} className={`w-4 h-4 ${i < n ? 'fill-amber-400 text-amber-400' : 'text-slate-300'}`} />
    ))}
  </div>
);

export const Testimonials = () => (
  <section id="success-stories" data-testid="testimonials-section" className="py-20 md:py-32 bg-[#F8FAFC] overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <SectionHeading
        label="Success Stories"
        title="Trusted by Teams That Move Fast"
        subtitle="100,000+ workforce hours delivered · 500+ workforce managed · Enterprise client engagements across India."
      />
    </div>
    <Marquee pauseOnHover speed={38} gradient gradientColor="#F8FAFC" gradientWidth={80}>
      {TESTIMONIALS.map((t, i) => (
        <div key={i} data-testid={`testimonial-card-${i}`}
          className="w-[380px] mx-3 p-7 bg-white border border-slate-200 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300">
          <div className="flex items-center justify-between">
            <Stars n={t.rating} />
            <Quote className="w-6 h-6 text-slate-200" />
          </div>
          <p className="mt-4 text-sm text-slate-700 leading-relaxed whitespace-normal">&ldquo;{t.text}&rdquo;</p>
          <div className="mt-6 flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-[#0A192F] text-white flex items-center justify-center text-sm font-bold font-heading">
              {t.name.split(' ').map((w) => w[0]).join('')}
            </div>
            <div>
              <div className="text-sm font-semibold text-[#0A192F]">{t.name}</div>
              <div className="text-xs text-slate-500">{t.role}</div>
            </div>
          </div>
        </div>
      ))}
    </Marquee>
  </section>
);
